"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/FeedbackModal/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _supportTicket = require('shared/constants/supportTicket');
var _session = require('shared/selectors/session');
var _hooks = require('web/services/hooks');


var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');
var _icons = require('./icons');









// Each Send is a new ticket: a chat with Support (CreateSupportTicket), which
// the app then opens. Mounted only while open, so each open starts fresh.
const FeedbackModal = ({ onClose, initialMessage = '', orgKey: ticketOrgKey }) => {
  const selectedOrgKey = _hooks.useAppSelector.call(void 0, _session.selectSelectedOrgKey)
  const orgKey = _nullishCoalesce(ticketOrgKey, () => ( selectedOrgKey))
  const [choice, setChoice] = _react.useState.call(void 0, _supportTicket.SUPPORT_TICKET_TYPES[0])
  const [message, setMessage] = _react.useState.call(void 0, initialMessage)
  const [error, setError] = _react.useState()
  const [isSending, setIsSending] = _react.useState.call(void 0, false)
  // A fast double click must not open two tickets.
  const isSendingRef = _react.useRef.call(void 0, false)

  const send = _react.useCallback.call(void 0, async (e) => {
    e.preventDefault()
    if (isSendingRef.current || !message.trim()) return
    isSendingRef.current = true
    setIsSending(true)
    setError(undefined)
    try {
      if (!orgKey) throw new Error('no selected org')
      const { Type, ConversationKey, BlobjectKey } = await _actions2.default.createSupportTicket({
        OrgKey: orgKey, Type: choice.type, Message: message,
      })
      onClose()
      _actions2.default.gotoBlobject(Type, ConversationKey, BlobjectKey)
    } catch (e2) {
      setError(_supportTicket.SUPPORT_TICKET_SEND_FAILED)
    } finally {
      isSendingRef.current = false
      setIsSending(false)
    }
  }, [choice, message, onClose, orgKey])

  const isBug = choice.type === 'bug'
  const BadgeIcon = isBug ? _icons.BugIcon : _icons.MessageIcon

  return (
    _react2.default.createElement(_Modal2.default, { isOpen: true, size: "xs", onClose: onClose, ariaLabel: choice.title, className: "feedback-modal", bodyClassName: "feedback-modal--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
      , _react2.default.createElement('button', { type: "button", 'aria-label': "Close", onClick: onClose, className: "blm-modal--close-btn feedback-modal--close" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}} )
      , _react2.default.createElement('form', { onSubmit: send, __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
        , _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'feedback-modal--badge', isBug && 'feedback-modal--badge--bug'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
          , _react2.default.createElement(BadgeIcon, { size: 24, __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}} )
        )
        , _react2.default.createElement('h3', { className: "feedback-modal--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}},  choice.title )
        , _react2.default.createElement('p', { className: "feedback-modal--prompt", __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}},  choice.prompt )
        , _react2.default.createElement('div', { className: "inbox-tabs feedback-modal--chips" , role: "group", 'aria-label': "Type", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
          ,  _supportTicket.SUPPORT_TICKET_TYPES.map(t => {
            const ChipIcon = _icons.CHIP_ICONS[t.type]
            return (
              _react2.default.createElement('button', {
                key: t.type,
                type: "button",
                className: _classBuilder2.default.call(void 0, 'inbox-tabs--chip', t === choice && 'is-on'),
                'aria-pressed': t === choice,
                onClick: () => setChoice(t), __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}

                , _react2.default.createElement(ChipIcon, { size: 14, __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}} ),  t.label 
              )
            )
          })
        )
        , _react2.default.createElement(_Form.InputSectionWrapper, { errorMessage: error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}
          , _react2.default.createElement(_Form.SimpleTextArea, {
            rows: 5,
            'aria-label': "Message",
            placeholder: choice.placeholder,
            value: message,
            onChange: e => setMessage(e.target.value),
            maxLength: undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
          )
        )
        , _react2.default.createElement(_Form.Button, { isSubmit: true, isLoading: isSending, isDisabled: !message.trim(), className: "feedback-modal--send", __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}, "Send"

        )
        , _react2.default.createElement('p', { className: "feedback-modal--after", __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}},  _supportTicket.SUPPORT_TICKET_AFTER_SEND )
      )
    )
  )
}

exports. default = FeedbackModal
